import NEXT_TRANSFER_TYPE from 'bl/payment/nextTransfertype.const';
import WEEKDAY from 'constants/time/weekday.const';
import determineWeekday from 'utils/date/determineWeekday.util';
import rotateWeekday from 'utils/date/rotateWeekday.util';
import nullBind from 'utils/functions/nullBind.util';
import withOptions from 'utils/functions/withOptions.util';

const nextDay = nullBind(rotateWeekday, 1);
const skipOne = nullBind(rotateWeekday, 2);
const skipTwo = nullBind(rotateWeekday, 3);
const skipThree = nullBind(rotateWeekday, 4);

// SEE: https://getslick.atlassian.net/browse/GS-11185
const PAYMENT_MAP = Object.freeze({
  [WEEKDAY.thu]: skipThree,
  [WEEKDAY.fri]: skipThree,
  [WEEKDAY.sat]: skipThree,
  [WEEKDAY.sun]: skipTwo,
  [WEEKDAY.mon]: skipOne,
  [WEEKDAY.tue]: nextDay,
  [WEEKDAY.wed]: nextDay,
});

const REFUND_MAP = Object.freeze({
  [WEEKDAY.fri]: skipTwo,
  [WEEKDAY.sat]: skipOne,
  [WEEKDAY.sun]: nextDay,
  [WEEKDAY.mon]: nextDay,
  [WEEKDAY.tue]: nextDay,
  [WEEKDAY.wed]: nextDay,
  [WEEKDAY.thu]: nextDay,
});

const DEFAULT_SKIP = nextDay;

const nextTransferWeekday = withOptions((options) => {
  const weekday = determineWeekday(options);
  if (Number.isNaN(weekday)) {
    return null;
  }

  const { type } = options;

  const map = type === NEXT_TRANSFER_TYPE.refund ? REFUND_MAP : PAYMENT_MAP;
  const skip = map[weekday] || DEFAULT_SKIP;

  return skip(weekday);
});

// noinspection JSUnusedGlobalSymbols
export default nextTransferWeekday;
